var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHamburgerMenuSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.071C3 5.478 3.478 5 4.071 5H21.93C22.522 5 23 5.478 23 6.071c0 .594-.478 1.072-1.071 1.072H4.07A1.069 1.069 0 0 1 3 6.07zm0 7.143c0-.594.478-1.071 1.071-1.071H21.93c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072H4.07A1.069 1.069 0 0 1 3 13.214zm20 7.143c0 .594-.478 1.071-1.071 1.071H4.07A1.069 1.069 0 0 1 3 20.357c0-.594.478-1.071 1.071-1.071H21.93c.593 0 1.071.477 1.071 1.071z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburgerMenuSmall);
export default __webpack_public_path__ + "static/media/icon-hamburger-menu-small.5bd6961f.svg";
export { ForwardRef as ReactComponent };